
import React from "react";
import { LIFE_STYLE_PERSONAL_DETAILS } from './LifeStylePersonalDetails_questions';
import { HEALTH_RECORDS } from './health_records_questions';
import { DIABETES_RECORDS } from './diabetes_questions';
import { COVID_RECORDS, AIR_RECORDS } from './covid_questions'
import { Accordion, Card } from 'react-bootstrap'
import {
  HYPERTENSION_RECORDS, OTHERS_RECORDS, FEMALELIFE_RECORDS, FAMILY_RECORDS,
  NRI_RECORDS, FAMILY_INCOME_RECORDS, INSURANCE_RECORDS
} from './question'
class QuestionRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: {},
      sections: []
    };
  }
  render() {
    return (
      <div className="main_container health_data">
        <Accordion defaultActiveKey="0" flush>
          <Accordion>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="0">
                Lifestyle and Personal Details

              </Accordion.Toggle>

              <Accordion.Collapse eventKey="0">
                {this.renderSection('LIFE_STYLE_PERSONAL_DETAILS', LIFE_STYLE_PERSONAL_DETAILS())}
              </Accordion.Collapse>
            </Card>

            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="1">
                Health Records
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="1">
                {this.renderSection('HEALTH_RECORDS', HEALTH_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="2">
                Annexure for Insurance Repository
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="2">
                {this.renderSection('ANNEXURE_INSURANCE_REPOSITORY', AIR_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="3">
                Covid Questions
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="3">
                {this.renderSection('COVID_QUESTION', COVID_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="4">
                Diabetes Questions
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="4">
                {this.renderSection('DIABETES_QUESTION', DIABETES_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="5">
                NRI Questions
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="5">
                {this.renderSection('NRI_QUESTIONS', NRI_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="6">
                Family History
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="6">
                {this.renderSection('FAMILY_HISTORY', FAMILY_RECORDS())}
              </Accordion.Collapse>
            </Card>
            
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="7">
                Femaile Life
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="7">
                {this.renderSection('FEMALE_LIFE', FEMALELIFE_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="8">
                Insurance History
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="8">
                {this.renderSection('INSURANCE_HISTORY', INSURANCE_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="9">
                Hypertension Questions
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="9">
                {this.renderSection('HYPERTENSION_QUESTION', HYPERTENSION_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="10">
                Family Income and Family Insurance
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="10">
                {this.renderSection('FAMILY_INCOME_FAMILY_INSURANCE', FAMILY_INCOME_RECORDS())}
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="11">
                Others
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="11">
                {this.renderSection('OTHERS', OTHERS_RECORDS())}
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Accordion>
      </div>
    )

  }
  renderSection = (section, questionData) => {
    return (
      <>
        {
          this.props.questions[section] && questionData[section] &&
          this.props.questions[section].map((item, index) => {
            return (
              <>
                <div
                  className={`${item.subQuestions && item.subQuestions.length > 0 ? 'list_proposal with-sub-questions' : 'list_proposal'}`}
                >
                  <div className="label">{questionData[section][item['questionSetCD']] &&
                    questionData[section][item['questionSetCD']][item['dataElementCD']] &&
                    questionData[section][item['questionSetCD']][item['dataElementCD']]['question']}</div>
                  <div className="value">{item.answer}</div>
                </div>

                {
                  item.subQuestions && item.subQuestions.length > 0 &&
                  <div className="sub-questions">
                    {
                      item.subQuestions.map(subQuestion => {
                        return (
                          <div className="list_proposal">
                            <div className="label">{
                              questionData[section][subQuestion['questionSetCD']] &&
                              questionData[section][subQuestion['questionSetCD']][subQuestion['dataElementCD']] &&
                              questionData[section][subQuestion['questionSetCD']][subQuestion['dataElementCD']]['question']}</div>
                            <div className="value">{subQuestion.answer}</div>
                          </div>
                        )
                      })
                    }
                  </div>
                }
              </>
            )
          })
        }
      </>
    )
  }

};

export default QuestionRenderer
